import React from 'react'
import styled from "styled-components"

import { typeLabel01, typeHeading02, typeBody02 } from '../../theme/typography'
import { unit, spacer, mediaQuery, SIZE } from '../../theme/metrics'

export const Wrapper = styled.section`
	display: flex;
	align-items: center;
	background-color: ${props => props.theme.background};
	min-height: calc(100vh - ${unit(9)});
`

export const Inner = styled.div`
	margin: 0 auto;
	flex: 1;
	max-width: 448px;
	text-align: center;
	padding: ${unit(5)} ${unit(3)};
`

export const Heading = styled.div`
	${typeHeading02}
	color: ${props => props.theme.foreground};
`

export const Text = styled.div`
	${typeBody02}
	color: ${props => props.theme.foreground};
	margin-top: ${unit(3)};

	a{
		color: ${props => props.theme.foreground};
		transition: opacity 0.3s;

		&:hover{
			opacity: 0.6;
		}
	}
`

export const Illustration = styled.svg`
	margin-bottom: ${unit(4)};
`